import React, { useState } from 'react'
import './styles.scss'
import VisibilitySensor from 'react-visibility-sensor'
import CountUp from 'react-countup'

export default function SmallCounterBoxBlock({
  number,
  unit,
  description,
  count,
}) {
  const [visible, setVisibility] = useState(false)
  const onChange = visibility => {
    if (visible != true) setVisibility(visibility)
  }
  return (
    <div className={'dhsv-small-counter-block'}>
      {number && (
        <div className={`small-counter-wrapper`} data-scroll>
          <h3 className={'small-counter'}>
            <VisibilitySensor
              partialVisibility
              offset={{ bottom: 100 }}
              onChange={onChange}
            >
              <div
                className={`small-counter-number ${getCharsNum(number)}`}
                style={{
                  width: '100',
                  height: '160px',
                }}
                data-scroll
              >
                {visible ? (
                  <CountUp
                    start={getStartNum(count, number)}
                    end={getEndNum(count, number)}
                    delay={0}
                    duration={3}
                    suffix={`<span class='small-counter-unit'>${unit}</span>`}
                  />
                ) : null}
              </div>
            </VisibilitySensor>
          </h3>
          {description && (
            <h4
              className={'small-counter-description'}
              data-scroll
              dangerouslySetInnerHTML={{ __html: description }}
            />
          )}
        </div>
      )}
      <script></script>
    </div>
  )
}

const getCharsNum = number => {
  if (number.length <= 2) {
    return 'big-font'
  } else {
    return 'small-font'
  }
}

const getStartNum = (count, number) => {
  switch (count) {
    case 'low_high':
      return '0'
    case 'high_low':
      return number
    default:
      return 'image-wrapper__16-9'
  }
}

const getEndNum = (count, number) => {
  switch (count) {
    case 'low_high':
      return number
    case 'high_low':
      return '0'
    default:
      return 'image-wrapper__16-9'
  }
}
